import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { environment } from '../../../../../environments/environment';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { UpdateLoaderVisibility } from '../../../shared/store/actions/loader.actions';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-reset-login',
  templateUrl: './reset-login.component.html',
  styleUrls: ['./reset-login.component.css'],
  standalone: false
})
export class ResetLoginComponent implements OnInit {

  restLoginSmsForm: FormGroup;
  restLoginByCodeForm: FormGroup;
  restLoginByBillIdForm: FormGroup;
  control: FormControl;
  restLoginSmsFormSubmitted: boolean;
  restLoginByCodeFormSubmitted: boolean;
  restLoginByBillIdFormSubmitted: boolean;
  recaptchaForm: string;
  confirmation: boolean;
  step: number;
  email: string;
  phoneNumber: string;
  errorMessage: string;
  errorMessageCode: string;
  errorMessageBillId: string;
  captchaToken: string;
  captchaKey: string;
  environment = environment;
  brand?: string;
  vitrineUrl?: string;

  breadcrumbDetails: any = [
    {
      url: environment.data.vitrineUrl,
      label: `Accueil`
    },
    {
      url: `/connexion`,
      label: `Identification`
    },
    {
      url: null,
      label: `Changer l'e-mail de mon compte client`
    }
  ];

  constructor(
      private router: Router,
      private formBuilder: FormBuilder,
      private loginService: LoginService,
      private store: Store<any>
  ) {}

  ngOnInit() {
    this.brand = environment.data.brand;
    this.vitrineUrl = environment.data.vitrineUrl;
    this.restLoginSmsFormSubmitted = false;
    this.restLoginByCodeFormSubmitted = false;
    this.restLoginByBillIdFormSubmitted = false;
    this.step = 1;
    this.email = null;
    this.phoneNumber = null;
    this.errorMessage = null;
    this.errorMessageCode = null;
    this.errorMessageBillId = null;
    this.captchaKey = null;
    this.captchaToken = null;
    this.recaptchaForm = null;
    this.captchaKey = environment.data.captchaKey;
    this.initForms();
  }

  initForms() {
    this.control = this.formBuilder.control('', Validators.required);
    this.restLoginSmsForm = this.formBuilder.group({});
    this.restLoginSmsForm.addControl('email', this.formBuilder.control('', [Validators.required, Validators.pattern(ConstsHelper.emailPattern)]));
    this.restLoginSmsForm.addControl('phoneNumber', this.formBuilder.control('', [Validators.required, Validators.pattern('^(\\+33|0)[1-9][0-9]{8}$')]));

    this.restLoginByCodeForm = this.formBuilder.group({});
    this.restLoginByCodeForm.addControl('code', this.formBuilder.control('', [Validators.required]));

    this.restLoginByBillIdForm = this.formBuilder.group({});
    this.restLoginByBillIdForm.addControl('billId', this.formBuilder.control('', [Validators.required]));
  }

  resolved(captchaResponse: string) {
    this.captchaToken = captchaResponse;
    if (this.captchaToken) {
      switch (this.recaptchaForm) {
        case 'sendSms':
          this.sendSms();
          break;
        case 'resetByCode':
          this.resetByCode();
          break;
        case 'resetByBillId':
          this.resetByBillId();
          break;
      }
    }
  }

  onLoginClick(captchaRef: any, form: string): void {
    this.recaptchaForm = form;
    this.store.dispatch(new UpdateLoaderVisibility(1));
    captchaRef.reset();
    captchaRef.execute();
  }

  errored(captchaRef: any) {
    captchaRef.reset();
    captchaRef.execute();
  }

  sendSms() {
    this.errorMessage = null;
    this.step = 1;
    this.restLoginSmsFormSubmitted = true;
    if (this.restLoginSmsForm.valid) {
      this.email = this.restLoginSmsForm.get('email').value;
      this.phoneNumber = this.restLoginSmsForm.get('phoneNumber').value;
      this.loginService.resetLoginSms(this.email, this.restLoginSmsForm.get('phoneNumber').value, this.captchaKey, this.captchaToken).subscribe(
          response => {
            this.store.dispatch(new UpdateLoaderVisibility(-1));
            this.step = 2;
            this.initForms();
          }, error => {
            this.store.dispatch(new UpdateLoaderVisibility(-1));
            if (error.error.error_message === 'email_is_used') {
              this.errorMessage = 'Cette adresse e-mail est déjà utilisée. Merci d\'utiliser une adresse e-mail différente.';
            } else if (error.error.error_message === 'invalid_number') {
              this.errorMessage = 'Veuillez saisir un numéro de ligne ' + this.formatBrandName() + ' valide.';
            } else if (error.error.error_message === 'pro_account') {
              this.errorMessage = `Cette procédure n'est pas disponible pour les comptes pros. Si vous êtes gestionnaire de flotte, merci de nous contacter à ` + environment.data.proEmail;
            }
          }
      );
    } else {
      this.store.dispatch(new UpdateLoaderVisibility(-1));
    }
  }

  resetByCode() {
    this.errorMessageCode = null;
    this.restLoginByCodeFormSubmitted = true;
    if (this.restLoginByCodeForm.valid) {
      this.loginService.resetLogin(this.email, this.phoneNumber, this.captchaKey, this.captchaToken, this.restLoginByCodeForm.get('code').value).subscribe(
          response => {
            this.store.dispatch(new UpdateLoaderVisibility(-1));
            this.step = 3;
            this.initForms();
          }, error => {
            this.store.dispatch(new UpdateLoaderVisibility(-1));
            if (error.error.error_message === 'email_is_used' || error.error.error_message === 'invalid_email') {
              this.errorMessageCode = 'Cette adresse e-mail est déjà utilisée. Merci d\'utiliser une adresse e-mail différente.';
            } else if (error.error.error_message === 'invalid_number' || error.error.error_message === 'invalid_phone_number') {
              this.errorMessageCode = 'Veuillez saisir un numéro de ligne ' + this.formatBrandName() + ' valide.';
            } else if (error.error.error_message === 'invalid_code') {
              this.errorMessageCode = 'Le code saisi est invalide.';
            } else if (error.error.error_message === 'pro_account') {
              this.errorMessageCode = `Cette procédure n'est pas disponible pour les comptes pros. Si vous êtes gestionnaire de flotte, merci de nous contacter à ` + environment.data.proEmail;
            }
          }
      );
    } else {
      this.store.dispatch(new UpdateLoaderVisibility(-1));
    }
  }

  resetByBillId() {
    this.errorMessageBillId = null;
    this.restLoginByBillIdFormSubmitted = true;
    if (this.restLoginByBillIdForm.valid) {
      this.loginService.resetLogin(this.email, this.phoneNumber, this.captchaKey, this.captchaToken, null, parseInt(this.restLoginByBillIdForm.get('billId').value, 10)).subscribe(
          response => {
            this.store.dispatch(new UpdateLoaderVisibility(-1));
            this.step = 3;
            this.initForms();
          }, error => {
            this.store.dispatch(new UpdateLoaderVisibility(-1));
            if (error.error.error_message === 'email_is_used' || error.error.error_message === 'invalid_email') {
              this.errorMessageBillId = 'Cette adresse e-mail est déjà utilisée. Merci d\'utiliser une adresse e-mail différente.';
            } else if (error.error.error_message === 'invalid_number' || error.error.error_message === 'invalid_phone_number') {
              this.errorMessageBillId = 'Veuillez saisir un numéro de ligne ' + this.formatBrandName() + ' valide.';
            } else if (error.error.error_message === 'invalid_bill_id') {
              this.errorMessageBillId = 'Le numéro de la facture est invalide.';
            } else if (error.error.error_message === 'pro_account') {
              this.errorMessageBillId = `Cette procédure n'est pas disponible pour les comptes pros. Si vous êtes gestionnaire de flotte, merci de nous contacter à ` + environment.data.proEmail;
            }
          }
      );
    } else {
      this.store.dispatch(new UpdateLoaderVisibility(-1));
    }
  }

  backToLoginPage() {
    this.router.navigate(['/connexion']);
  }

  formatBrandName() {
    return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
  }
}
